export default {
    data(){
        return{
            invalidCards: [
                '0000000000000000',
                '8888888888888888'
            ],
            brands:{
                'visa'       : /^4\d{12}(\d{3})?$/,
                'mastercard' : /^(5[1-5]\d{4}|677189)\d{10}$/,
                'diners'     : /^3(0[0-5]|[68]\d)\d{11}$/,
                'discover'   : /^6(?:011|5[0-9]{2})[0-9]{12}$/,
                'elo'        : /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})$/,
                'amex'       : /^3[47]\d{13}$/,
                'jcb'        : /^(?:2131|1800|35\d{3})\d{11}$/,
                'hipercard'  : /^(606282\d{10}(\d{3})?)|(3841\d{15})$/,
            },

        }
    },
    methods: {
        isValidCardNumber(number) {
            let value = number.replace(/\D/g,'');

            for(let card in this.invalidCards){

                if(this.invalidCards[card]=== number){

                    return false;
                }
            }

            let sum = 0;
            let shouldDouble = false;

            for(var i = value.length -1; i >= 0; i--){
                let digit = parseInt(value.charAt(i));

                if(shouldDouble) {
                    if((digit *= 2) > 9) digit -=9;
                }

                sum +=digit;
                shouldDouble = !shouldDouble;
            }
            return (sum%10) == 0;
        },



        getBrand(card) {
            let haveBrand = false
            if(card){
                let value = card.replace(/\D/g,'');

                for(let brand in this.brands){
                    if(value.match(this.brands[brand])){
                        haveBrand = brand;

                    }
                }
            }

            return haveBrand

        }

    }
}
